import { useTheme } from '@mui/material/styles';
import React from 'react';

interface DividerWithTextProps {
    children: React.ReactNode;
}

export const DividerWithText: React.FC<DividerWithTextProps> = ({ children }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ borderBottom: '2px solid lightgray', width: '100%' }} />
        <span
            style={{
                paddingTop: useTheme().spacing(0.5),
                paddingBottom: useTheme().spacing(0.5),
                paddingRight: useTheme().spacing(2),
                paddingLeft: useTheme().spacing(2),
                fontWeight: 500,
                fontSize: 22,
                color: 'lightgray',
            }}
        >
            {children}
        </span>
        <div style={{ borderBottom: '2px solid lightgray', width: '100%' }} />
    </div>
);
